"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "RelationUpdateWebhookHandler", {
    enumerable: true,
    get: function() {
        return RelationUpdateWebhookHandler;
    }
});
const _updatewebhookhandler = require("~/db/update-webhook-handler");
let RelationUpdateWebhookHandler = class RelationUpdateWebhookHandler {
    static async beginUpdate(payload, rowId) {
        const relationUpdateWebhookHandler = new RelationUpdateWebhookHandler(payload, rowId.parent, rowId.child);
        await relationUpdateWebhookHandler.sendBeforeUpdateWebhook();
        return relationUpdateWebhookHandler;
    }
    // // experimental, will be useful after refactoring
    // public static async manageWebhook(
    //   payload: RelationUpdateWebhookContext,
    //   rowId: {
    //     parent: any;
    //     child: any;
    //   },
    //   handler: () => Promise<void> | Promise<any>,
    // ) {
    //   const relationUpdateWebhookHandler = await this.beginUpdate(payload, rowId);
    //   const handlerResult = await handler();
    //   await relationUpdateWebhookHandler.finishUpdate();
    //   return handlerResult;
    // }
    async sendBeforeUpdateWebhook() {
        this.parentUpdateWebhookHandler = await _updatewebhookhandler.UpdateWebhookHandler.beginUpdate({
            context: this.relationWebhookContext.parentBaseModel.context,
            user: this.relationWebhookContext.user,
            baseModel: this.relationWebhookContext.parentBaseModel,
            isSingleUpdate: true,
            ignoreWebhook: this.relationWebhookContext.ignoreWebhook
        }, this.parentRowId);
        if (this.relationWebhookContext.parentBaseModel.model.id !== this.relationWebhookContext.childBaseModel.model.id || this.parentRowId !== this.childRowId) {
            this.childUpdateWebhookHandler = await _updatewebhookhandler.UpdateWebhookHandler.beginUpdate({
                context: this.relationWebhookContext.childBaseModel.context,
                user: this.relationWebhookContext.user,
                baseModel: this.relationWebhookContext.childBaseModel,
                isSingleUpdate: true,
                ignoreWebhook: this.relationWebhookContext.ignoreWebhook
            }, this.childRowId);
        }
    }
    async addAffectedParentId(parentRowId) {
        this.affectedParentUpdateWebhookHandler = await _updatewebhookhandler.UpdateWebhookHandler.beginUpdate({
            context: this.relationWebhookContext.parentBaseModel.context,
            user: this.relationWebhookContext.user,
            baseModel: this.relationWebhookContext.parentBaseModel,
            isSingleUpdate: true,
            ignoreWebhook: this.relationWebhookContext.ignoreWebhook
        }, parentRowId);
    }
    async addAffectedChildId(childRowId) {
        this.affectedChildUpdateWebhookHandler = await _updatewebhookhandler.UpdateWebhookHandler.beginUpdate({
            context: this.relationWebhookContext.childBaseModel.context,
            user: this.relationWebhookContext.user,
            baseModel: this.relationWebhookContext.childBaseModel,
            isSingleUpdate: true,
            ignoreWebhook: this.relationWebhookContext.ignoreWebhook
        }, childRowId);
    }
    async finishUpdate() {
        await this.parentUpdateWebhookHandler.finishUpdate();
        if (this.childUpdateWebhookHandler) {
            await this.childUpdateWebhookHandler.finishUpdate();
            if (this.affectedChildUpdateWebhookHandler) {
                await this.affectedChildUpdateWebhookHandler.finishUpdate();
            }
            if (this.affectedParentUpdateWebhookHandler) {
                await this.affectedParentUpdateWebhookHandler.finishUpdate();
            }
        }
    }
    constructor(relationWebhookContext, parentRowId, childRowId){
        this.relationWebhookContext = relationWebhookContext;
        this.parentRowId = parentRowId;
        this.childRowId = childRowId;
    }
};
